import { useState } from 'react';
import { useParams } from 'react-router-dom';

import { Icon } from '@flintmint/web-shared/components/icon';
import { WorkspaceSidebarList } from '@/features/workspace-sidebar';
import { InitialSyncBanner } from '@/components/initial-sync-banner';
import { AddUserSourceModal } from '@/components/add-user-source-modal';

import { useDocuMenu } from '@/hooks/use-docu-menu';

import { cortexNoDataDescriptions } from '@/constants/ui';

export const Cortex = () => {
  const [openFileUploadOpen, setFileUploadOpen] = useState(false);

  const { id: activeDocumentId } = useParams();

  const menuData = useDocuMenu();

  return (
    <>
      <WorkspaceSidebarList
        searchParamKey="search"
        getSearchableTypes={() => ['userSources']}
        searchQuery={{
          where: {
            excludeSourceKinds: ['audio', 'image'],
          },
        }}
        getNoDataConfig={() => ({
          icon: 'ai-brain-03',
          descriptions: cortexNoDataDescriptions,
          defaultActions: [
            {
              icon: 'plus',
              label: 'New Item',
              onClick: () => setFileUploadOpen(true),
            },
          ],
        })}
        renderActions={() => (
          <Icon size={20} type="plus" data-testid="left-sidebar-plus-btn" onClick={() => setFileUploadOpen(true)} />
        )}
        docuListProps={{
          menu: menuData,
          'data-testid': 'cortex',
          appearance: 'greyscale',
          showDescription: false,
          selections: [],
          activeDocumentId,
          searchableTypes: ['userSources'],
          listHeader: <InitialSyncBanner />,
        }}
      />
      <AddUserSourceModal open={openFileUploadOpen} onClose={() => setFileUploadOpen(false)} />
    </>
  );
};
